export const getWindowMode = state => state.global.currentWindowMode;